import { nativeApplicationVersion } from "expo-application";
import Constants from "expo-constants";
import { Platform } from "react-native";

export const isNativeDevice = Platform.OS !== "web";

export const isAndroid = Platform.OS === "android";

export const isIos = Platform.OS === "ios";

export const currentVersion = isNativeDevice
  ? nativeApplicationVersion
  : Constants?.expoConfig?.version;
